module.exports = __webpack_public_path__ + "img/master_seriesZ9F.e8ff99cf.png";